import { Card, CardContent } from "../../components/ui/card";
import { Coins, TrendingUp, Clock, CheckCircle } from "lucide-react";
import { formatCurrency } from "../../lib/currency";

const PayrollStats = ({ stats, currency }) => {
  const fmt = (amount) => formatCurrency(amount, currency);

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      <Card className="card-soft">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-violet-100">
              <Coins className="h-5 w-5 text-violet-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-slate-800">{stats?.totalRecords || 0}</p>
              <p className="text-xs text-slate-500">Payroll Records</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className="card-soft">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-emerald-100">
              <TrendingUp className="h-5 w-5 text-emerald-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-slate-800">{fmt(stats?.totalPayout || 0)}</p>
              <p className="text-xs text-slate-500">Total Payout</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className="card-soft">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-amber-100">
              <Clock className="h-5 w-5 text-amber-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-slate-800">{stats?.pending || 0}</p>
              <p className="text-xs text-slate-500">Pending</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className="card-soft">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-green-100">
              <CheckCircle className="h-5 w-5 text-green-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-slate-800">{stats?.processed || 0}</p>
              <p className="text-xs text-slate-500">Processed</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PayrollStats;
